import React from "react";

import { Form } from "react-final-form";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { defineMessages, useIntl } from "@mnemonic/intl";
import { LinearProgress } from "@mnemonic/mui";
import { extractErrorMessage } from "@mnemonic/redux-utils";

import { LoginBoxActions, LoginBoxCallout } from "../../Components/Login/Layout";
import { TextField } from "../../Components/MuiFinalForm";
import { TokenProblems } from "../../Components/TokenProblems";
import {
  useAuthorizeEnrollmentMutation,
  useRequestAuthorizationTokenEnrollmentQuery,
} from "../../Redux/Service/authorizeApi";
import { commonMessages } from "../../commonMessages";
import { redirectToValidatedNextURI } from "../../utils/nextURIRedirect";
import type { TOperation } from "./utils/OperationUtils";
import { redirectWithState } from "./utils/redirectWithState";
import validateEmptyField from "./utils/validateEmptyField";

export interface IEnrollmentProps {
  context?: { [key: string]: string };
  nextURI: string;
  operation: TOperation;
}
const messages = defineMessages({
  codeEnrollment: { id: "login.EnrollmentCode", defaultMessage: "Enrollment code" },
  helperTextEnrollment: {
    id: "login.helper.Enrollment.token",
    defaultMessage: "Enter the code received on your phone",
  },
});

export const AuthorizationWithEnrollment = ({ context, nextURI, operation }: IEnrollmentProps) => {
  const {
    isLoading: isLoadingCookie,
    data,
    error: errorCookie,
  } = useRequestAuthorizationTokenEnrollmentQuery({ criteria: undefined });
  const [authorizeEnrollment, { isLoading: isAuthorizeEnrollmentLoading, error: errorAuthorizeEnrollment }] =
    useAuthorizeEnrollmentMutation();
  const intl = useIntl();
  const errorMessage = extractErrorMessage(errorAuthorizeEnrollment || errorCookie);
  const isLoading = isLoadingCookie || isAuthorizeEnrollmentLoading;

  return (
    <>
      <LinearProgress loading={isLoading} />
      <Form
        initialValues={{ token: null }}
        onSubmit={(formValues: { token: string }) =>
          authorizeEnrollment({ criteria: { ...formValues, operation, nextURI, context, cookie: data?.data?.cookie } })
            .unwrap()
            ?.then(({ data }) => {
              redirectWithState(data);
            })
        }
        render={({ handleSubmit }) => {
          return (
            <form onSubmit={handleSubmit}>
              <TextField
                name="token"
                autoComplete="off"
                fullWidth
                helperText={intl.formatMessage(messages.helperTextEnrollment)}
                label={intl.formatMessage(messages.codeEnrollment)}
                validate={(value: string) => validateEmptyField(value)}
              />
              <Box sx={{ p: 1 }}>{data?.data?.cookie && <TokenProblems cookie={data?.data?.cookie} />}</Box>
              <LoginBoxActions>
                <div>
                  <Button
                    disabled={isLoading}
                    style={{ marginRight: 8 }}
                    onClick={() => void redirectToValidatedNextURI(nextURI)}
                  >
                    {intl.formatMessage(commonMessages.Cancel)}
                  </Button>
                  <Button
                    color="secondary"
                    disabled={isLoading || isAuthorizeEnrollmentLoading}
                    type="submit"
                    variant="contained"
                  >
                    {intl.formatMessage(commonMessages.Authorize)}
                  </Button>
                </div>
              </LoginBoxActions>
              {errorMessage && <LoginBoxCallout type="error">{errorMessage}</LoginBoxCallout>}
            </form>
          );
        }}
      />
    </>
  );
};
